var path = 'app/scripts/modules/cloudfoundry/serverGroup/configure/wizard/services.html';
var html = "<form name=\"form\" class=\"container-fluid form-horizontal\" ng-controller=\"cfServerGroupServicesCtrl as servicesCtrl\" novalidate>\n  <div class=\"modal-body\">\n    <cf-server-group-services-selector command=\"command\" application=\"application\"></cf-server-group-services-selector>\n  </div>\n</form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/cloudfoundry/serverGroup/configure/wizard/services.html
// module id = 1654
// module chunks = 0